import {
  DoctypeFiltersResponse,
  SummaryPaymentResponse,
} from '../../types/payment-status';
import { AssignedProjectsListReportResponse } from '../../types/projects';
import { PAYMENT_STATUS } from '../endpoints';
import request from '../request';

export interface ParametersPagination {
  page: string;
  itemsPerPage: string;
}

export interface ParametersPaymentsDetail {
  searchDocumentNum?: string;
  searchRut?: string;
  searchFromDate?: string;
  searchToDate?: string;
  searchDoctype?: string;
}

export interface ParametersProjectsAssignedPagination
  extends ParametersPagination,
    ParametersPaymentsDetail {
  search?: string;
}

/**
 * Obtiene el listado de proyectos asociados a un usuario
 */
export const getProjectsAssignedForPaymentStatus = (
  userId: number,
  paginationParams: ParametersProjectsAssignedPagination,
) => {
  return request<AssignedProjectsListReportResponse>(
    PAYMENT_STATUS.GET_ASSIGNED(userId),
    {
      params: paginationParams,
    },
  );
};

/**
 * Lista el resumen de pagos asociados a un proyecto por tipo de pago
 */
export const getPaymentsSummaryToProjectAssigned = (
  paymentType: string,
  projectCode: string,
  paginationParams: ParametersProjectsAssignedPagination,
) => {
  return request<SummaryPaymentResponse>(
    PAYMENT_STATUS.GET_SUMMARY_BY_PAYMENT_STATUS_TYPE(paymentType, projectCode),
    {
      params: paginationParams,
    },
  );
};

/**
 * Lista los tipos de documentos para filtrar
 */
export const getDocumentTypeFilter = (
  paymentType: string,
  projectCode: string,
) => {
  return request<DoctypeFiltersResponse[]>(
    PAYMENT_STATUS.GET_FILTER_BY_PAYMENT_STATUS_TYPE(paymentType, projectCode),
  );
};

/**
 * Lista el resumen de pagos asociados a un proyecto por tipo de pago y lo exporta a EXCEL
 */
export const getPaymentsSummaryToExcel = async (
  paymentType: string,
  projectCode: string,
  params: ParametersPaymentsDetail,
) => {
  return await request(
    PAYMENT_STATUS.GET_PAYMENT_SUMMARY_BY_PAYMENT_STATUS_TYPE_EXPORT_EXCEL(
      paymentType,
      projectCode,
    ),
    {
      responseType: 'blob',
      params,
    },
  );
};

/**
 * Lista el resumen de pagos asociados a un proyecto por tipo de pago y lo exporta a PDF
 */
export const getPaymentsSummaryToPdf = async (
  paymentType: string,
  projectCode: string,
  params: ParametersPaymentsDetail,
) => {
  return await request(
    PAYMENT_STATUS.GET_PAYMENT_SUMMARY_BY_PAYMENT_STATUS_TYPE_EXPORT_PDF(
      paymentType,
      projectCode,
    ),
    {
      responseType: 'blob',
      params,
    },
  );
};
